/* eslint-disable promise/param-names */
/* eslint-disable */
import {
  AUTH_REQUEST,
  AUTH_SIGNUP,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
} from '@/store/actions/auth';
import { apiCall, api_routes } from '@/utils/api';
import router from './../../router';

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  hasLoadedOnce: false,
};

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
};

const actions = {
  [AUTH_REQUEST]: ({ commit }, user) => new Promise((resolve, reject) => {
    commit(AUTH_REQUEST);
    apiCall({ url: api_routes.user.login, data: user, method: 'post' })
      .then((resp) => {
        // console.log('response', resp)
        localStorage.setItem('user', JSON.stringify(resp.user));
        localStorage.setItem('user-token', resp.token);
        commit(AUTH_SUCCESS, resp);
        localStorage.setItem('user-token', resp.token);
        // Here set the header of your ajax library to the token value.
        // example with axios
        // axios.defaults.headers.common['Authorization'] = resp.token
        resolve(resp);
      })
      .catch((err) => {
        console.log('errror', err)
        commit(AUTH_ERROR, err);
        localStorage.removeItem('user-token');
        localStorage.removeItem('user');
        reject(err);
      });
  }),
  [AUTH_SIGNUP]: ({ commit }, user) => new Promise((resolve, reject) => {
    commit(AUTH_REQUEST);
    apiCall({ url: api_routes.user.signup, data: user, method: 'post' })
      .then((resp) => {
        localStorage.setItem('user-token', resp.token);
        localStorage.setItem('user', JSON.stringify(resp.user));
        commit(AUTH_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [AUTH_LOGOUT]: ({ commit }) => new Promise((resolve) => {
    commit(AUTH_LOGOUT);
    localStorage.removeItem('user-token');
    localStorage.clear();
    router.push('/login');
    resolve();
  }),
};

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.token = resp.token;
    state.user = resp.user;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '';
    state.user = '';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
